module.exports = __webpack_public_path__ + "img/2023big22.1b178544.png";